// Animation
export const SET_SHOW = 'SET_SHOW';

// Nav
export const SET_TRIGGER_VISIBLE = 'SET_TRIGGER_VISIBLE';
export const SET_NAV_VISIBLE = 'SET_NAV_VISIBLE';
